export default __webpack_public_path__ + "d81d522a19f3840b4c4e72f2cb5d527a.png";